{
  "slug": "what-is-considered-a-high-iq",
  "title": "什么是高智商?",
  "description": "了解哪些智商分数通常被描述为高,它们与百分比的关系,以及置信区间和测试环境为什么重要。",
  "summary": "一个共同的平均-100,标准偏差-15 尺度，分数在 周围 120 远远高于平均水平,得分在 周围 130 标签因乐器而异,不应取代完整的解释。",
  "category": "智商分数解释",
  "sections": [
    {
      "heading": "共同分数和百分比参考点",
      "paragraphs": [
        "现代智商分数描述了相对于基于年龄的标准群体的表现。 100 是靠近 50百分位数， 115 附近的 84星期一 120 附近的 911 位，并且 130 附近的 98这些是正常模型的近似值,而不是通用的截止值。",
        "出版商和组织使用不同的描述,例如高于平均、优秀、非常高或天赋等术语可能有不同的界限,因此报告及其技术手册优先。"
      ],
      "bullets": [
        "110–119: 高于总体平均数",
        "120–129: 许多尺度上远高于平均水平",
        "130 上面的两个字,是指“上面”和“上面”的意思。100, SD- 无法确定15 模型"
      ]
    },
    {
      "heading": "高复合材料可能包含不均匀的轮廓",
      "paragraphs": [
        "某人可能在语言推理、视觉推理、工作记忆或处理速度方面表现特别出色,而另一个领域则接近其年龄组的平均水平。",
        "个人资料、测试条件、语言、教育、健康和评估原因比单一标签更重要,高分并不意味着个性、创造力、动机或未来成就。"
      ]
    },
    {
      "heading": "准确和负责任的解释",
      "paragraphs": [
        "专业报告通常包括置信区间,因为 的结果是 的结果。 129 不是有意义地分离. 130 由一个完美的精确边界。",
        "关于教育、临床支持或资格的决定应该依赖于适当的监督仪器和合格的解释,并且应该考虑到患者的个人情况。"
      ]
    }
  ],
  "faqs": [
    {
      "question": "是智商 的 120 被认为是高的？",
      "answer": "是的,是的。 91平均值的第100分位数100, SD- 无法确定15 模型,通常被描述为高于平均水平,但标签因测试而异。"
    },
    {
      "question": "高智商是否保证成功?",
      "answer": "成功还取决于知识、动机、健康、个性、机会、坚持不懈和环境。"
    }
  ],
  "related": ["what-does-an-iq-of-120-mean", "iq-130-meaning", "iq-score-ranges-explained"],
  "sources": [
    {
      "label": "心理学词典 — IQ",
      "url": "https://dictionary.apa.org/iq"
    },
    {
      "label": "皮尔逊-西非信息系统5 样本得分报告",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report.pdf"
    }
  ]
}
